import { hookstate } from '@hookstate/core'

const globalSurveyStore = hookstate({
});

export default globalSurveyStore;